import type { RecommendHistoryMetadata } from '@app/api/RecommendChat/types';

import type { WithActiveBranchId } from '../shared';

export enum ActionsHistoryEndpoints {
  GetUserActionHistory = 'GetUserActionHistory',
  GetClientActionHistory = 'GetClientActionHistory',
  GetLeadClientActionHistory = 'GetLeadClientActionHistory',
  GetRecordActionHistory = 'GetRecordActionHistory',
  GetLeadClientActionHistoryFilters = 'GetLeadClientActionHistoryFilters',
  SetLeadClientActionHistoryFilters = 'SetLeadClientActionHistoryFilters',
}

export interface ModelActionHistoryItem {
  Icon: string | null;
  ValueOld: string | null;
  ValueNew: string | null;
  Property: string | null;
}

export interface ModelClientFile {
  Id: number;
  TimeCreated: string;
  ClientId: number;
  Description: string | null;
  FileName: string | null;
  FileSize: number;
  Data: string | null;
  Extension: string | null;
  Thumbnail: string | null;
  ClientMessageId: number | null;
  // Свойства Duration в Сваггере нет, но на деле сервер (GetLeadClientActionHistory) его возвращает
  // в виде строки, а фронт использует его для рендера (на 24.10.2024). Во избежание багов ему
  // дополнительно был присвоен тип null, чтобы фронт убеждался о его заполненности перед рендером
  Duration: string | null;
  ExternalAccessId?: string | null;
}

export type ModelActionHistoryClientFile = ModelClientFile;

export interface ModelActionChatMessage {
  RecommendChat?: RecommendHistoryMetadata | null;
  MessageId: number;
  Type: string | null;
  Timestamp: string;
  ClientId: number;
  UserId: number;
  BranchId: number;
  BranchName: string | null;
  UserFirstName: string | null;
  UserLastName: string | null;
  UserPhoto: string | null;
  SocialIntegrationId: number;
  Direction: string | null;
  Status: string | null;
  ErrorMessage: string | null;
  Message: string | null;
  Transcription: string | null;
  File: ModelClientFile | null;
  FileId: number;
  WasEdited: boolean;
  ReactionEmojiOwn: string | null;
  ReactionEmojiCompanion: string | null;
  LocationLatLon: string | null;
  LocationAddress: string | null;
  LocationName: string | null;
  ReplyClientMessageId: number | null;
  ReplyClientMessage: string | null;
  IsForwarded: boolean;
  SenderAccountLogin: string | null;
  ReceiverAccountLogin: string | null;
  SocialIntegrationName: string | null;
  SocialType: string | null;
  SocialTypeUserFriendly: string | null;
  IsFromOutside: boolean;
  IsAiOperator: boolean;
  Grade: number | null;
  AiRecommendations: string | null;
}

export interface ModelActionHistory {
  IdS: string | null;
  Timestamp: string;
  ActionId: string | null;
  ActionUserId: number;
  ObjectId: number;
  Icon: string | null;
  ActionUser: string | null;
  ObjectType: string | null;
  ObjectS: string | null;
  ActionText: string | null;
  IsImportantAction: boolean;
  ActionItems: ModelActionHistoryItem[] | null;
  Files: ModelClientFile[] | null;
  ChatMessages: ModelActionChatMessage[] | null;
}

export type GetUserActionHistoryRequest = WithActiveBranchId<{
  forUserId: number;
  dateS: string;
  dateE: string;
}>;

export type GetClientActionHistoryRequest = WithActiveBranchId<{
  forClientId: number;
  dateS: string;
  dateE: string;
}>;

export type GetLeadClientActionHistoryRequest = WithActiveBranchId<{
  forClientId: number;
  dateS: string;
  dateE: string;
}>;

export type GetRecordActionHistoryRequest = WithActiveBranchId<{
  recordId: number;
  dateS: string;
  dateE: string;
}>;

export type GetUserActionHistoryResponse = ModelActionHistory[];
export type GetClientActionHistoryResponse = ModelActionHistory[];
export type GetLeadClientActionHistoryResponse = ModelActionHistory[];
export type GetRecordActionHistoryResponse = ModelActionHistory[];

/**
 * Выключенные пользователем фильтры истории карточки лида (us/11168).
 * Хранятся только скрытые значения: новые ActionId и SocialType, которых нет
 * в сохранённых списках, показываются включёнными. Пустые списки — ничего не
 * скрыто.
 */
export interface ModelLeadClientActionHistoryFilters {
  /** ActionId типов действий, которые пользователь скрыл */
  HiddenActionIds: string[] | null;
  /** SocialType интеграций, которые пользователь скрыл */
  HiddenSocialTypes: string[] | null;
}

export type GetLeadClientActionHistoryFiltersRequest = WithActiveBranchId;
export type GetLeadClientActionHistoryFiltersResponse =
  ModelLeadClientActionHistoryFilters;

// POST перезаписывает значение целиком, ответ — сохранённое состояние.
export type SetLeadClientActionHistoryFiltersRequest = WithActiveBranchId<{
  data: ModelLeadClientActionHistoryFilters;
}>;
export type SetLeadClientActionHistoryFiltersResponse =
  ModelLeadClientActionHistoryFilters;
